import Home from './Home'
import { I18nextProvider } from 'react-i18next'
import React from 'react'
import initI18n from '../i18next'

const IndexPage = () => (
  <>
    <Home/>
  </>
)

export default IndexPage
